import type { CoachVoiceTemplateProfile } from "@/lib/behavior/coachVoiceTemplate";

export interface CoachVoiceDraft {
  voiceSummary: string;
  questionStems: string[];
  phraseBank: string[];
  avoidList: string[];
  coachingMoves: string[];
  guardrails: string[];
}

export function createDefaultCoachVoiceDraft(): CoachVoiceDraft {
  return {
    voiceSummary: "",
    questionStems: [],
    phraseBank: [],
    avoidList: [],
    coachingMoves: [],
    guardrails: [],
  };
}

export function coachVoiceDraftFromTwinJson(twinJson: unknown): CoachVoiceDraft {
  const base = createDefaultCoachVoiceDraft();
  if (!twinJson || typeof twinJson !== "object") return base;
  const value = twinJson as Record<string, unknown>;
  const toStringArray = (input: unknown) =>
    Array.isArray(input) ? input.filter((item): item is string => typeof item === "string") : [];

  return {
    voiceSummary: typeof value.voice_summary === "string" ? value.voice_summary : "",
    questionStems: toStringArray(value.question_stems),
    phraseBank: toStringArray(value.phrase_bank),
    avoidList: toStringArray(value.avoid_list),
    coachingMoves: toStringArray(value.coaching_moves),
    guardrails: toStringArray(value.guardrails),
  };
}

export function coachVoiceDraftToTwinJson(draft: CoachVoiceDraft) {
  return {
    voice_summary: draft.voiceSummary,
    question_stems: draft.questionStems,
    phrase_bank: draft.phraseBank,
    avoid_list: draft.avoidList,
    coaching_moves: draft.coachingMoves,
    guardrails: draft.guardrails,
  };
}

export function coachVoiceDraftFromTemplateProfile(profile: CoachVoiceTemplateProfile): CoachVoiceDraft {
  return {
    voiceSummary: profile.voiceSummary,
    questionStems: profile.questionStems,
    phraseBank: profile.phraseBank,
    avoidList: profile.avoidList,
    coachingMoves: profile.coachingMoves,
    guardrails: profile.guardrails,
  };
}
